import { useMemo } from "react";
import { barRuns, encodeBarcode, humanText } from "@/lib/barcode";

export function BarcodeSvg({ code, digitsPt, testId }) {
  const enc = useMemo(() => encodeBarcode(code), [code]);
  if (!enc) return <div className="tag-bc-bad" data-testid={testId}>Can't encode “{code}”</div>;
  const total = enc.quiet[0] + enc.bits.length + enc.quiet[1];
  return (
    <div className="tag-bc" data-format={enc.format} data-code={code} data-testid={testId}>
      <svg className="tag-bars" viewBox={`0 0 ${total} 10`} preserveAspectRatio="none" shapeRendering="crispEdges" role="img" aria-label={`${enc.format} ${code}`}>
        {barRuns(enc.bits, enc.quiet[0]).map(([x, w]) => (
          <rect key={x} x={x} y={0} width={w} height={10} fill="#000" />
        ))}
      </svg>
      <div className="tag-digits" style={{ fontSize: `${digitsPt}pt` }}>{humanText(code, enc.format)}</div>
    </div>
  );
}
